module.exports = __webpack_public_path__ + "img/brockhaus.4068af20.png";